var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderNotchPlus = function SvgIconFolderNotchPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.875a1 1 0 0 1 1-1H11v-1.25a1 1 0 1 1 2 0v1.25h1.25a1 1 0 1 1 0 2H13v1.25a1 1 0 1 1-2 0v-1.25H9.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.333 6.5 9.796 4.6l-.002-.002A1.76 1.76 0 0 0 8.75 4.25H3.75A1.75 1.75 0 0 0 2 6v12.75a1.75 1.75 0 0 0 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V8.25a1.75 1.75 0 0 0-1.75-1.75zM4 8.75v-2.5h4.664l1.668 1.25-1.668 1.25zm4.747 2v-1l.004 1a1.76 1.76 0 0 0 1.043-.348l.002-.002 2.537-1.9H20v10H4v-7.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderNotchPlus;